import { useState } from "react";
import { authClient } from "../lib/auth";
import type { Me } from "../lib/useMe";

export function ProfilePage({ me, onChanged }: { me: Me; onChanged: () => void }) {
  const [name, setName] = useState(me.user.name);
  const [image, setImage] = useState(me.user.image || "");
  const [msg, setMsg] = useState("");
  const save = async (e: React.FormEvent) => {
    e.preventDefault();
    const res = await authClient.updateUser({ name, image: image || null });
    setMsg(res.error ? res.error.message || "Could not save" : "Saved");
    if (!res.error) onChanged();
  };
  return (
    <>
      <h1>Profile</h1>
      <form className="card" style={{ maxWidth: 480 }} onSubmit={save}>
        <label className="field">Name<input value={name} onChange={e => setName(e.target.value)} /></label>
        <label className="field">Email<input value={me.user.email} disabled /></label>
        <label className="field">Avatar URL<input value={image} onChange={e => setImage(e.target.value)} placeholder="https://…" /></label>
        <button className="btn primary">Save</button> {msg && <span className={msg === "Saved" ? "ok" : "error"}>{msg}</span>}
      </form>
    </>
  );
}
